import { LazyLaunchHelpPane } from 'owa-header-pane';
import { isFeatureEnabled } from 'owa-feature-flags';
import { launchSuiteHelpPane } from 'owa-suite-header';

export function mailHelpPaneRouteHandler() {
    isFeatureEnabled('fwk-o365shellheader')
        ? launchSuiteHelpPane()
        : LazyLaunchHelpPane.importAndExecute();
}
